import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import ImageUpload from "src/Components/GlobalComponents/ImageUplaod";
import PrimaryBtn from "src/Components/GlobalComponents/primaryBtn";
import SelectDropdown from "src/Components/GlobalComponents/SelectDropdown";
import httpRequest from "src/helpers/httpRequest";
import { IHomePageInterface } from "src/types/GlobalInterfaces";
import { useSelector } from "react-redux";
import { RootState } from "@store/store";
import { canWrite } from "src/helpers/helperFunctions";
interface IProps {
  data: any;
  setData: React.Dispatch<React.SetStateAction<IHomePageInterface | null>>;
}

const DoctorBannerSection09: React.FC<IProps> = ({
  data,
  setData,
}) => {
  const { userDetails } = useSelector((store: RootState) => store.appReducer);
  const hasWriteAccess = canWrite(userDetails, "platformManagement", false);
  const [isLoader, setIsLoader] = useState<boolean>(false);
  const [doctorBanner, setDoctorBanner] = useState<File | null | string>(
    null
  );
  const [doctorBanner2, setDoctorBanner2] = useState<File | null | string>(
    null
  );
  const [doctorBanner3, setDoctorBanner3] = useState<File | null | string>(
    null
  );
  const [doctorBanner4, setDoctorBanner4] = useState<File | null | string>(
    null
  );

  const handleSubmit = async () => {
    if (!hasWriteAccess) {
      return;
    }

    if (!doctorBanner || !doctorBanner2 || !doctorBanner3 || !doctorBanner4) {
      toast.error("Please upload all banners");
      return;
    }

    let formData = new FormData();
    formData.append("bannerOne", doctorBanner);
    formData.append("bannerTwo", doctorBanner2);
    formData.append("bannerThree", doctorBanner3);
    formData.append("bannerFour", doctorBanner4);
    setIsLoader(true);

    let { res, err } = await httpRequest({
      path: "/website-manage/section-nine",
      method: "put",
      params: formData,
      header : {
        "Content-Type": "multipart/form-data",
      },
    });

    if (res) {
      toast.success("Doctor banner updated successfully");
    } else {
      toast.error(err);
    }
    setIsLoader(false);
  };

  useEffect(() => {
    if (data) {
      setDoctorBanner(data?.bannerOne || "");
      setDoctorBanner2(data?.bannerTwo || "");
      setDoctorBanner3(data?.bannerThree || "");
      setDoctorBanner4(data?.bannerFour || "");
    }
  }, [data]);

  return (
    <div className="section__2">
      <h1 className="font-Poppins-SemiBold font-size-25px mb-2 theme-color-green">
        Section 09
      </h1>
      <div className="products-tabs-content">
        <h3 className="font-size-18px text-[#2F2F31] mb-3 font-Poppins-Regular">
          Doctor Banner
        </h3>
        <div className="grid grid-cols-2 gap-5 gap-x-10">
          <div className="w-full">
            <ImageUpload
              newUi={true}
              image={doctorBanner}
              onImageChange={setDoctorBanner}
              extraClasses={"w-full min-h-[340px]"}
              labelId={`doctor-banner-one`}
              disabled={!hasWriteAccess}
            />
          </div>
          <div className="w-full">
            <ImageUpload
              newUi={true}
              image={doctorBanner2}
              onImageChange={setDoctorBanner2}
              extraClasses={"w-full min-h-[340px]"}
              labelId={`doctor-banner-two`}
              disabled={!hasWriteAccess}
            />
          </div>
          <div className="w-full">
            <ImageUpload
              newUi={true}
              image={doctorBanner3}
              onImageChange={setDoctorBanner3}
              extraClasses={"w-full min-h-[340px]"}
              labelId={`doctor-banner-three`}
              disabled={!hasWriteAccess}
            />
          </div>
          <div className="w-full">
            <ImageUpload
              newUi={true}
              image={doctorBanner4}
              onImageChange={setDoctorBanner4}
              extraClasses={"w-full min-h-[340px]"}
              labelId={`doctor-banner-four`}
              disabled={!hasWriteAccess}
            />
          </div>
        </div>
      </div>
      <div className="flex justify-end mt-3">
        <PrimaryBtn
          loader={isLoader}
          ButtonText="Save"
          btnExtraStyle={{ backgroundColor: "#00443f", borderRadius: "1.5rem" }}
          onPress={() => {
            if (!hasWriteAccess) {
              return;
            }
            handleSubmit();
          }}
          id="doctor-banner-save"
          disabled={!hasWriteAccess}
          btnExtralClasses={`${!hasWriteAccess ? "cursor-not-allowed" : ""}`}
        />
      </div>
    </div>
  );
};

export default DoctorBannerSection09;
